import { render } from "./PayesAndImpayes.vue?vue&type=template&id=07964fec"
import script from "./PayesAndImpayes.vue?vue&type=script&lang=js"
export * from "./PayesAndImpayes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__